import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../app/store';
import { Token, tokens } from '../components/data';
export interface TokenState {
    token: Token;
    placeholder: string;
}

const initialState: TokenState = {
    token:Token.WBTC,
    placeholder: tokens[Token.WBTC][0],
};

export const tokenSlice = createSlice({
    name: 'token',
    initialState,
    // The `reducers` field lets us define reducers and generate associated actions
    reducers: {        
        setToken: (state: TokenState, action: PayloadAction<Token>) => {
            state.token = action.payload;
        },
        setPlaceholder: (state: TokenState, action: PayloadAction<string>) => {
            state.placeholder = action.payload;
        },
    },
});

export const { setToken, setPlaceholder } = tokenSlice.actions;

export const selectToken = (state: RootState) => state.token.token;
export const selectPlaceholder = (state: RootState) => state.token.placeholder;

export default tokenSlice.reducer;
